/* ============================================================
   Tapanda Audit Wave 0 — opt-in JS
   Obsługuje:
     B8  — click-outside-to-close wyszukiwarki
     B17 — ukrywanie line item property „Available Product"
          w koszyku (cart page + cart drawer + cart notification)

   Plik wczytywany z defer w layout/theme.liquid. Nie nadpisuje
   istniejących handlerów — tylko dodaje nowe listenery.
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     B8 — Click-outside-to-close dla wyszukiwarki
     Wyszukiwarka: komponent #dT_top-sticky w header.
     Otwarcie dodaje klasę `search-show` na ancestorze.
     Zamknięcie wywołujemy klikając w istniejący close button
     (.search-modal__close-button lub button[aria-label="Close"]).
     ---------------------------------------------------------- */
  function initSearchClickOutside() {
    // Upewniamy się, że listener montujemy tylko raz
    if (window.__tapandaSearchClickOutsideInit) return;
    window.__tapandaSearchClickOutsideInit = true;

    document.addEventListener(
      'click',
      function (event) {
        // Znajdź otwartą wyszukiwarkę (klasa search-show na ancestorze)
        var openedSearch = document.querySelector(
          '.search-show .search-modal, .search-show.search-modal, details-modal.search-modal[open], details[open] > .search-modal'
        );
        // Dodatkowy fallback: sprawdź kontener headerowy
        if (!openedSearch) {
          var stickyHeader = document.querySelector(
            '#dT_top-sticky.header__search.search-show, .header__search.search-show'
          );
          if (stickyHeader) {
            openedSearch = stickyHeader.querySelector('.search-modal') || stickyHeader;
          }
        }
        if (!openedSearch) return;

        var target = event.target;
        if (!target || !(target instanceof Node)) return;

        // Szukaj faktycznego obszaru wyszukiwarki (content + hosta)
        var searchContent = openedSearch.querySelector
          ? openedSearch.querySelector('.search-modal__content, form.search-modal__form')
          : null;

        // Jeśli klik był w obszar wyszukiwarki (content, form, results),
        // w ikonę wyszukiwania w headerze (otwierająca), lub w ikonę search —
        // nie zamykaj.
        var clickInsideContent =
          searchContent && searchContent.contains(target);
        var clickOnCloseButton =
          target.closest &&
          (target.closest('.search-modal__close-button') ||
            target.closest('#dT_TopStickySearchBtn') ||
            target.closest('.search-icon'));

        // Klik w otwierający przycisk search (ikona lupy) — nie zamykamy,
        // bo to zachowanie toggle obsługuje istniejący komponent
        if (clickOnCloseButton) return;
        if (clickInsideContent) return;

        // Klik poza wyszukiwarką — zamykamy przez symulację klika w X
        var closeBtn = openedSearch.querySelector
          ? openedSearch.querySelector('.search-modal__close-button')
          : null;
        if (!closeBtn) {
          // Fallback — szukaj w całym headerze
          closeBtn = document.querySelector(
            '.header__search.search-show .search-modal__close-button, .search-show .search-modal__close-button'
          );
        }
        if (closeBtn && typeof closeBtn.click === 'function') {
          try {
            closeBtn.click();
          } catch (_err) {
            /* no-op */
          }
        } else {
          // Drugi fallback — usuń klasę search-show z hosta
          var host = document.querySelector('.header__search.search-show, #dT_top-sticky.search-show');
          if (host && host.classList) {
            host.classList.remove('search-show');
          }
        }
      },
      true // capture — żeby zadziałało przed ewentualnym stopPropagation w innych handlerach
    );

    // Escape key — zamykaj wyszukiwarkę jeśli otwarta i listener nie istnieje
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      var openedHost = document.querySelector(
        '#dT_top-sticky.search-show, .header__search.search-show'
      );
      if (!openedHost) return;
      var closeBtn = openedHost.querySelector('.search-modal__close-button');
      if (closeBtn && typeof closeBtn.click === 'function') {
        try {
          closeBtn.click();
        } catch (_err) {
          /* no-op */
        }
      }
    });
  }

  /* ----------------------------------------------------------
     B17 — Ukrywanie line item property „Available Product"
     Iteruje wszystkie .product-option w koszyku (cart page,
     cart drawer, cart notification). Jeśli pierwszy <dt>
     zawiera tekst rozpoczynający się od "Available Product",
     element zostaje ukryty (style.display = 'none').
     Działa:
       - przy inicjalizacji,
       - po każdej zmianie DOM w tych kontenerach (MutationObserver),
       - po eventach `cart:update`, `cart:refresh`, `cart:updated`
         (zachowawczy fallback dla różnych shopowych skryptów).
     Nie rusza innych line item properties ani logiki koszyka.
     ---------------------------------------------------------- */
  var AVAILABLE_PRODUCT_KEYS = [
    'available product',
    'available product:',
    'available product :'
  ];

  function isAvailableProductDt(dtEl) {
    if (!dtEl || !dtEl.textContent) return false;
    var raw = dtEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    // Usuwamy końcowy dwukropek (znaki trailing)
    var normalized = raw.replace(/[:\s]+$/, '').trim();
    if (!normalized) return false;
    return (
      normalized === 'available product' ||
      normalized.indexOf('available product') === 0
    );
  }

  function hideAvailableProductOption(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selectors = [
      '.cart-items .product-option',
      '.cart-page .product-option',
      '#main-cart-items .product-option',
      '.cart-drawer .product-option',
      '.cart-notification .product-option',
      'cart-items .product-option',
      'cart-drawer .product-option',
      'cart-drawer-items .product-option'
    ];
    var allNodes = [];
    selectors.forEach(function (sel) {
      try {
        var nodes = scope.querySelectorAll(sel);
        for (var i = 0; i < nodes.length; i++) {
          allNodes.push(nodes[i]);
        }
      } catch (_err) {
        /* invalid selector — ignore */
      }
    });

    allNodes.forEach(function (node) {
      if (!node || node.dataset.tapandaAvailableHidden === '1') return;
      var dt = node.querySelector && node.querySelector('dt');
      if (!dt) return;
      if (isAvailableProductDt(dt)) {
        node.style.display = 'none';
        node.setAttribute('aria-hidden', 'true');
        node.dataset.tapandaAvailableHidden = '1';
      }
    });
  }

  function attachCartObservers() {
    var targets = [
      document.getElementById('main-cart-items'),
      document.querySelector('.cart-drawer'),
      document.querySelector('cart-drawer'),
      document.querySelector('cart-items'),
      document.querySelector('.cart-notification'),
      document.querySelector('cart-notification')
    ].filter(Boolean);

    if (!targets.length) return;

    targets.forEach(function (el) {
      if (el.__tapandaAvailableObserver) return;
      var observer = new MutationObserver(function () {
        hideAvailableProductOption(el);
      });
      observer.observe(el, { childList: true, subtree: true });
      el.__tapandaAvailableObserver = observer;
    });
  }

  function initAvailableProductHide() {
    // Pierwsze przejście na DOM
    hideAvailableProductOption(document);
    // Obserwatorzy mutacji w kontenerach koszyka
    attachCartObservers();

    // Fallback: nasłuchuj typowych eventów koszyka
    var cartEvents = ['cart:updated', 'cart:update', 'cart:refresh', 'cart:change'];
    cartEvents.forEach(function (evtName) {
      document.addEventListener(evtName, function () {
        // krótkie opóźnienie — pozwól wyrenderować markup
        setTimeout(function () {
          hideAvailableProductOption(document);
          attachCartObservers();
        }, 50);
      });
    });

    // Dodatkowy fallback — Shopify theme editor może swap'ować sekcje
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () {
        hideAvailableProductOption(document);
        attachCartObservers();
        dedupeDesktopSideMenu();
      }, 50);
    });
  }

  /* ----------------------------------------------------------
     Bootstrap — odpal po DOMContentLoaded
     ---------------------------------------------------------- */
  function dedupeDesktopSideMenu() {
    /* Tapanda: wszystkie zakładki żyją teraz w jednej pigułce nawigacji (header pill-nav),
       a boczne menu jest ukrywane CSS-em na desktopie. Nie chowamy duplikatów w pigułce,
       bo to one mają być widoczne. (Drawer mobilny czyta hrefy osobno — nietknięty.) */
    return;
    // eslint-disable-next-line no-unreachable
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
    var sideHrefs = {};
    document.querySelectorAll('.tapanda-header-side-menu__list a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (href) sideHrefs[href] = true;
    });
    if (!Object.keys(sideHrefs).length) return;
    document.querySelectorAll('.dt-desktop-menu a.dt-sc-nav-link[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (!sideHrefs[href]) return;
      var listItem = anchor.closest('li');
      if (listItem) listItem.style.setProperty('display', 'none', 'important');
    });
  }

  function initDrawerSideMenu() {
    var SIDE_LINKS = [
      { href: '/pages/o-nas', text: 'O nas' },
      { href: '/pages/realizacje', text: 'Realizacje' }
    ];
    function collectSideLinks() {
      var links = [];
      var seen = {};
      document.querySelectorAll('.tapanda-header-side-menu__list a[href]').forEach(function (anchor) {
        var href = anchor.getAttribute('href') || '';
        var text = (anchor.textContent || '').trim();
        if (!href || !text || seen[href]) return;
        seen[href] = true;
        links.push({ href: href, text: text });
      });
      SIDE_LINKS.forEach(function (item) {
        if (!seen[item.href]) {
          links.push(item);
          seen[item.href] = true;
        }
      });
      return links;
    }
    function ensureDrawerSideMenu() {
      var drawer = document.getElementById('menu-drawer');
      if (!drawer || drawer.querySelector('.tapanda-drawer-side-menu')) return;
      var mainMenu = drawer.querySelector('.menu-drawer__menu');
      if (!mainMenu) return;
      var ul = document.createElement('ul');
      ul.className = 'menu-drawer__menu list-menu tapanda-drawer-side-menu';
      ul.setAttribute('role', 'list');
      collectSideLinks().forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'top-level-link dt-sc-child tapanda-drawer-side-nav';
        var a = document.createElement('a');
        a.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        a.href = item.href;
        a.textContent = item.text;
        li.appendChild(a);
        ul.appendChild(li);
      });
      mainMenu.insertAdjacentElement('afterend', ul);
    }
    ensureDrawerSideMenu();
    var toggle = document.querySelector('#Details-menu-drawer-container summary, header-drawer summary');
    if (toggle && !toggle.dataset.tpSideMenuBound) {
      toggle.dataset.tpSideMenuBound = '1';
      toggle.addEventListener('click', function () {
        setTimeout(ensureDrawerSideMenu, 0);
        setTimeout(ensureDrawerSideMenu, 150);
      });
    }
  }

  function applyDynamicAccessibleNames(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.tee-quantity .tee-field__title').forEach(function (title) {
      title.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && node.nodeValue.trim() === 'Quantity') {
          node.nodeValue = node.nodeValue.replace('Quantity', 'Ilość');
        }
      });
    });

    scope.querySelectorAll('.tee-quantity-input[placeholder="Qty"]').forEach(function (input) {
      input.setAttribute('placeholder', 'Ilość');
    });

    scope.querySelectorAll('.jm-product-variant-card__thumbnail[aria-label], .jm-product-variant-card__product-link[aria-label]').forEach(function (link) {
      var label = link.getAttribute('aria-label');
      var match = /^View (.+) product page$/.exec(label);
      if (match) link.setAttribute('aria-label', 'Zobacz stronę produktu ' + match[1]);
    });

    scope.querySelectorAll('.jm-pagination-controls[aria-label], .jm-pagination-controls button[aria-label]').forEach(function (control) {
      var label = control.getAttribute('aria-label');
      var translated = '';
      if (label === 'Pagination Navigation') translated = 'Nawigacja po stronach opinii';
      if (label === 'Go to previous page') translated = 'Przejdź do poprzedniej strony';
      if (label === 'Go to next page') translated = 'Przejdź do następnej strony';
      var page = /^Go to page ([1-9]\d*)$/.exec(label);
      if (page) translated = 'Przejdź do strony ' + page[1];
      if (translated) control.setAttribute('aria-label', translated);
    });

    scope.querySelectorAll('.tee-quantity-input:not([aria-label])').forEach(function (input) {
      input.setAttribute('aria-label', 'Ilość produktu');
      input.setAttribute('inputmode', 'numeric');
    });

    scope.querySelectorAll('.tee-quantity-minus, .tee-quantity-plus').forEach(function (control) {
      if (control.dataset.tapandaA11yReady === '1') return;
      var isMinus = control.classList.contains('tee-quantity-minus');
      control.dataset.tapandaA11yReady = '1';
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', isMinus ? 'Zmniejsz ilość produktu' : 'Zwiększ ilość produktu');
      control.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        control.click();
      });
    });

    scope.querySelectorAll('.jm-medals__medal-link:not([aria-label])').forEach(function (link) {
      var title = link.querySelector('svg title');
      var label = title && title.textContent ? title.textContent.trim() : '';
      link.setAttribute('aria-label', label || 'Informacje o certyfikacie opinii Judge.me');
    });

    scope.querySelectorAll('.jdgm-star[data-alt]').forEach(function (star) {
      var rating = parseInt(star.getAttribute('data-alt'), 10);
      if (!rating) return;
      var suffix = rating === 1 ? 'gwiazdka' : rating < 5 ? 'gwiazdki' : 'gwiazdek';
      var label = rating + ' ' + suffix;
      if (star.getAttribute('aria-label') !== label) star.setAttribute('aria-label', label);
    });

    scope.querySelectorAll('.tee-radio.tee-swatch input[type="radio"], input[type="radio"][name^="color-"]').forEach(function (radio) {
      if (radio.getAttribute('aria-label') || radio.getAttribute('aria-labelledby')) return;
      var label = radio.id ? document.querySelector('label[for="' + CSS.escape(radio.id) + '"]') : null;
      var accessibleName = radio.value || (label && (label.dataset.title || label.title));
      if (accessibleName) radio.setAttribute('aria-label', accessibleName);
    });

    scope.querySelectorAll('.tee-option-inner[role="radiogroup"][aria-labelledby]').forEach(function (group) {
      var labelledBy = group.getAttribute('aria-labelledby');
      if (!labelledBy || document.getElementById(labelledBy)) return;
      var option = group.closest('.tee-option');
      var title = option && option.querySelector('.tee-option__title');
      var groupName = title && title.textContent ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!groupName) return;
      group.setAttribute('aria-label', groupName);
      group.removeAttribute('aria-labelledby');
    });

    scope.querySelectorAll('.tee-row[role="radiogroup"][aria-labelledby]').forEach(function (group) {
      var labelledBy = group.getAttribute('aria-labelledby');
      if (!labelledBy || document.getElementById(labelledBy)) return;
      var field = group.closest('.tee-field');
      var title = field && (
        field.querySelector('.tee-field__heading') ||
        field.querySelector('.tee-field__title') ||
        field.querySelector('.tee-option__title') ||
        field.querySelector('legend')
      );
      var groupName = title && title.textContent ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!groupName) return;
      group.setAttribute('aria-label', groupName);
      group.removeAttribute('aria-labelledby');
    });

    scope.querySelectorAll('#jdgm-tab_product_reviews[aria-controls], #jdgm-tab_shop_reviews[aria-controls]').forEach(function (tab) {
      var panelId = tab.getAttribute('aria-controls');
      if (panelId && !document.getElementById(panelId)) tab.removeAttribute('aria-controls');
    });

    scope.querySelectorAll('.tapanda-song-placeholder__title').forEach(function (heading) {
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  }

  function repairDynamicDuplicateIds() {
    document.querySelectorAll('.jdgm-write-review-modal__field-error[id^="jdgm-review-stars-error"]').forEach(function (error, index) {
      var targetId = index === 0 ? 'jdgm-review-stars-error' : 'jdgm-review-stars-error-' + (index + 1);
      error.id = targetId;
      var group = error.closest('.jdgm-write-review-modal__field-group--stars');
      var stars = group && group.querySelector('.jdgm-write-review-modal__stars');
      if (stars) stars.setAttribute('aria-describedby', targetId);
    });

    document.querySelectorAll('g.tee-layer-photo[id] > g.tee-layer-image[id]').forEach(function (inner) {
      var outer = inner.parentElement;
      if (!outer || !outer.id || inner.id !== outer.id) return;
      inner.id = outer.id + '--inner';
    });
  }

  var teeHiddenCleanupTimer = null;

  function repairTeeinblueHiddenCloneIds() {
    var visibleForm = document.querySelector('[id^="MainProduct-"] .tee-form-wrapper #teeAtcButton');
    if (!visibleForm) return;

    document.querySelectorAll('#teeinblue-wrapper .teeinblue-hidden').forEach(function (container, containerIndex) {
      container.setAttribute('aria-hidden', 'true');
      container.setAttribute('inert', '');
      var prefix = 'tp-tee-hidden-' + (containerIndex + 1) + '-';

      container.querySelectorAll('[id]').forEach(function (element) {
        var originalId = element.id;
        if (!originalId || originalId.indexOf(prefix) === 0) return;
        var selector = '#' + CSS.escape(originalId);
        var hasOutsideDuplicate = Array.prototype.some.call(document.querySelectorAll(selector), function (candidate) {
          return candidate !== element && !container.contains(candidate);
        });
        if (!hasOutsideDuplicate) return;
        element.dataset.tapandaOriginalId = originalId;
        element.id = prefix + originalId;
      });
    });
  }

  function scheduleTeeinblueHiddenCleanup() {
    if (teeHiddenCleanupTimer) return;
    teeHiddenCleanupTimer = setTimeout(function () {
      teeHiddenCleanupTimer = null;
      repairTeeinblueHiddenCloneIds();
    }, 1500);
  }

  function initDynamicAccessibleNames() {
    applyDynamicAccessibleNames(document);
    repairDynamicDuplicateIds();
    scheduleTeeinblueHiddenCleanup();
    var target = document.body;
    if (!target || target.__tapandaA11yObserver) return;
    var repairScheduled = false;
    var observer = new MutationObserver(function (records) {
      var needsRepair = false;
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          var changed = record.target;
          if (changed.matches && changed.matches('.jdgm-star[data-alt], #jdgm-tab_product_reviews, #jdgm-tab_shop_reviews, .jm-product-variant-card__thumbnail[aria-label], .jm-product-variant-card__product-link[aria-label], .jm-pagination-controls[aria-label], .jm-pagination-controls button[aria-label]')) {
            applyDynamicAccessibleNames(changed.parentElement || changed);
          }
          return;
        }
        if (record.target.matches && record.target.matches('.tee-quantity .tee-field__title')) {
          applyDynamicAccessibleNames(record.target.parentElement || record.target);
        }
        needsRepair = true;
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (
            node.matches('.tee-quantity .tee-field__title, .tee-quantity-input, .tee-quantity-minus, .tee-quantity-plus, .tee-radio.tee-swatch input[type="radio"], input[type="radio"][name^="color-"], .tee-row[role="radiogroup"][aria-labelledby], .jm-medals__medal-link, .jdgm-star, .tapanda-song-placeholder__title, .jm-product-variant-card__thumbnail, .jm-product-variant-card__product-link, .jm-pagination-controls, .jm-pagination-controls button[aria-label]')
          )) {
            applyDynamicAccessibleNames(node.parentElement || node);
            return;
          }
          applyDynamicAccessibleNames(node);
        });
      });
      if (!needsRepair || repairScheduled) return;
      scheduleTeeinblueHiddenCleanup();
      repairScheduled = true;
      setTimeout(function () {
        repairScheduled = false;
        repairDynamicDuplicateIds();
      }, 0);
    });
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'aria-controls'] });
    target.__tapandaA11yObserver = observer;
  }

  /* ----------------------------------------------------------
     Cookies koszyka — flaga Secure na storefront HTTPS.

     Shopify i Omnisend zapisują część dostępnych dla JS cookies
     koszyka bez atrybutu Secure. Atrybut nie jest częścią tożsamości
     cookie, więc ponowny zapis tej samej nazwy/domeny/ścieżki może go
     bezpiecznie uzupełnić bez zmiany tokenu koszyka. Okres ważności
     odpowiada temu, który ustawia storefront Shopify (31 dni), a
     localization zachowuje roczny okres. Cookie Omnisend pozostaje
     sesyjne.
     ---------------------------------------------------------- */
  function initSecureCartCookies() {
    if (window.__tapandaSecureCartCookiesInit) return;
    if (window.location.protocol !== 'https:' || !navigator.cookieEnabled) return;
    window.__tapandaSecureCartCookiesInit = true;

    var hostCookieMaxAge = {
      cart: 60 * 60 * 24 * 31,
      cart_currency: 60 * 60 * 24 * 31,
      localization: 60 * 60 * 24 * 365
    };
    var shopDomain = window.location.hostname.replace(/^www\./i, '');

    function hardenSecureCartCookies() {
      if (window.location.protocol !== 'https:') return;

      String(document.cookie || '').split(';').forEach(function (part) {
        var separatorIndex = part.indexOf('=');
        if (separatorIndex < 1) return;

        var name = part.slice(0, separatorIndex).trim();
        var value = part.slice(separatorIndex + 1);

        if (Object.prototype.hasOwnProperty.call(hostCookieMaxAge, name)) {
          document.cookie =
            name + '=' + value +
            '; Path=/; Max-Age=' + hostCookieMaxAge[name] +
            '; SameSite=Lax; Secure';
          return;
        }

        if (name === 'omnisendShopifyCart' && shopDomain) {
          document.cookie =
            name + '=' + value +
            '; Path=/; Domain=' + shopDomain +
            '; SameSite=Lax; Secure';
        }
      });
    }

    hardenSecureCartCookies();
    window.setTimeout(hardenSecureCartCookies, 1500);
    window.setTimeout(hardenSecureCartCookies, 5000);

    ['cart:updated', 'cart:refresh', 'product:added'].forEach(function (eventName) {
      document.addEventListener(eventName, hardenSecureCartCookies);
    });

    if (typeof window.fetch === 'function' && !window.fetch.__tapandaSecureCartCookies) {
      var originalFetch = window.fetch;
      var wrappedFetch = function () {
        var request = arguments[0];
        var requestUrl = typeof request === 'string'
          ? request
          : request && request.url
            ? request.url
            : '';
        var isCartRequest = false;

        try {
          var pathname = new URL(requestUrl, window.location.href).pathname;
          isCartRequest = /^\/cart(?:\/|\.js$)/.test(pathname);
        } catch (_error) {
          isCartRequest = false;
        }

        var responsePromise = originalFetch.apply(this, arguments);
        if (!isCartRequest || !responsePromise || typeof responsePromise.then !== 'function') {
          return responsePromise;
        }

        return responsePromise.then(
          function (response) {
            window.setTimeout(hardenSecureCartCookies, 0);
            return response;
          },
          function (error) {
            throw error;
          }
        );
      };

      wrappedFetch.__tapandaSecureCartCookies = true;
      window.fetch = wrappedFetch;
    }
  }

  function initReviewTransparency(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var widgets = [];

    if (root.matches && root.matches('.jdgm-widget.jdgm-review-widget')) {
      widgets.push(root);
    }
    root.querySelectorAll('.jdgm-widget.jdgm-review-widget').forEach(function (widget) {
      widgets.push(widget);
    });

    widgets.forEach(function (widget) {
      var previous = widget.previousElementSibling;
      if (previous && previous.classList.contains('tp-review-transparency')) return;

      var details = document.createElement('details');
      details.className = 'tp-review-transparency';

      var summary = document.createElement('summary');
      summary.textContent = 'Jak weryfikujemy opinie?';

      var description = document.createElement('p');
      description.textContent =
        'Etykieta „Zweryfikowany zakup” oznacza powiązanie opinii z zamówieniem lub kontem klienta. ' +
        'Opinie bez takiego potwierdzenia nie otrzymują tej etykiety. Pokazujemy także opinie krytyczne, ' +
        'a moderujemy spam i treści naruszające zasady. Ocena może łączyć opinie o produktach z tej samej ' +
        'rodziny oferowanych w różnych wariantach lub stylach.';

      details.appendChild(summary);
      details.appendChild(description);
      widget.parentNode.insertBefore(details, widget);
    });

    if (!window.__tapandaReviewTransparencyListener) {
      window.__tapandaReviewTransparencyListener = true;
      document.addEventListener('shopify:section:load', function (event) {
        initReviewTransparency(event.target);
      });
    }
  }

  function boot() {
    try {
      initSearchClickOutside();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initSearchClickOutside error:', err);
    }
    try {
      initAvailableProductHide();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initAvailableProductHide error:', err);
    }
    try {
      dedupeDesktopSideMenu();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] dedupeDesktopSideMenu error:', err);
    }
    try {
      initDrawerSideMenu();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initDrawerSideMenu error:', err);
    }
    try {
      initDynamicAccessibleNames();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initDynamicAccessibleNames error:', err);
    }
    try {
      initSecureCartCookies();
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initSecureCartCookies error:', err);
    }
    try {
      initReviewTransparency(document);
    } catch (err) {
      console.warn('[tapanda-audit-wave-0] initReviewTransparency error:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
